export default __webpack_public_path__ + "static/media/card-project6.650ffa92.png";